<div class="container-fluid">
  <div class="row">
    <div class="col-md-2 col-lg-3"></div>
    <div class="col-md-8 col-lg-6">
      <div class="card mb-3" *ngIf="isLoaded" [@fadeInAnimation]>
        <div class="card-header">
          <fa-icon [icon]="['fas', 'sign-in-alt']" size="lg" class="mr-2" [fixedWidth]="true"></fa-icon>{{ 'label.mina-inloggningar' | translate }}
        </div>
        <div class="card-body">
          <p class="h5">{{ 'label.valj-instans' | translate }}</p>
          <button *ngFor="let i of instances" class="btn-garanti btn-pink btn-block" [class.active]="i.id===lastInstanceId && i.roleType===lastRoleType" (click)="setInstance(i)">
            <ng-container *ngIf="i.roleType !== 'arb'">
              Som {{ i.roleName.toLowerCase() }} i {{ i.name }}
            </ng-container>
            <ng-container *ngIf="i.roleType === 'arb'">
              {{ i.debtorName }} <span *ngIf="i.caseType">({{ i.caseType }})</span>
            </ng-container>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
